import { Box, Flex, Image, Text, UseDisclosureReturn } from '@chakra-ui/react';
import React from 'react';
import { TransactionModal } from './atoms/modal/txmodal';
import StepButtons from './step-buttons';
import { themeVariables } from '../theme';

interface TransactionSubmittedProps {
  title?: string;
  description?: string;
  route?: string;
  onClose: () => void;
  routeText?: string;
  background?: string;
}

const poweredByLogo =
  'https://bjlavcngusgdszvtjwdr.supabase.co/storage/v1/object/public/Images//powered_white_stacked.png';

export const TransactionSubmitted: React.FC<TransactionSubmittedProps> = ({
  onClose,
  title = 'Transaction Submitted',
  description = 'Please allow some minutes for your transaction to process on-chain',
  route = 'orders',
  routeText = 'Order',
  background,
}) => {
  return (
    <>
      <Flex
        background={background ? background : themeVariables.background.modal}
        flexDir="column"
        width="full"
        height="full"
        maxWidth="376px"
        minHeight="274px"
        gap="1.5rem"
        padding="1rem 2.5rem"
        alignItems={'center'}
        mx={'auto'}
      >
        <Box>
          <Image src={poweredByLogo} />
        </Box>
        <Flex
          flexDirection={'column'}
          gap={'5px'}
          width={'100%'}
          alignItems={'center'}
        >
          <Text
            fontSize="18px"
            fontWeight="500"
            lineHeight="28px"
            textAlign="center"
            color={themeVariables.offWhite.offWhite400}
          >
            {title}
          </Text>
          <Text
            color={themeVariables.neutral[400]}
            fontSize="16px"
            fontWeight={400}
            lineHeight="24px"
            textAlign="center"
          >
            {description}
          </Text>
        </Flex>
        <StepButtons
          poweredBy={false}
          rightText={`View ${routeText}`}
          rightOnclick={() => {
            window.open(
              `https://preprod.meteraprotocol.io/me/${route}`,
              '_blank',
            );
          }}
          leftText="Close"
          leftOnclick={onClose}
        />
      </Flex>
    </>
  );
};

interface TransactionSubmittedModalProps extends TransactionSubmittedProps {
  disc: UseDisclosureReturn;
  onClose: () => void;
}

function TransactionSubmittedModal({
  disc,
  onClose,
  title,
  description,
  route,
  routeText,
}: TransactionSubmittedModalProps) {
  return (
    <TransactionModal
      {...disc}
      isOpen={disc.isOpen}
      maxWidth="376px"
      minHeight="274px"
    >
      <TransactionSubmitted onClose={onClose} />
    </TransactionModal>
  );
}

export default TransactionSubmittedModal;
